import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, Typography } from '@mui/material';
import PublicPrivateToggle from '../../../../components/PublicPrivateToggle';
import PdfIcon from '../../../../icons/components/pdf-icon';
var DocumentFileItem = function (_a) {
    var id = _a.id, fileName = _a.fileName, fileSize = _a.fileSize, isSelected = _a.isSelected, isPublic = _a.isPublic, onToggleSelect = _a.onToggleSelect, onToggleVisibility = _a.onToggleVisibility;
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            padding: '16px',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            marginLeft: 2,
            alignItems: 'flex-start'
            // '&:before': {
            //   content: '""',
            //   position: 'absolute',
            //   left: 4,
            //   top: 33,
            //   width: 28,
            //   borderTop: '2px dotted #C4CDD5'
            // }
        }, children: [_jsx(Checkbox, { checked: isSelected, onChange: function () { return onToggleSelect(id); }, color: 'primary', size: 'small', sx: { padding: '8px' } }), _jsx(Box, { sx: { pt: '6px' }, children: _jsx(PdfIcon, { width: 20, height: 20 }) }), _jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    flex: 1,
                    minWidth: 0
                }, children: [_jsx(Typography, { variant: 'body2', sx: {
                            color: 'text.primary',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }, children: fileName }), _jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }, children: _jsx(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }, children: _jsx(Typography, { sx: {
                                    fontFamily: 'Public Sans',
                                    fontWeight: 400,
                                    fontSize: 12,
                                    color: 'text.disabled'
                                }, children: fileSize }) }) }), _jsx(Box, { sx: { marginTop: '8px' }, children: _jsx(PublicPrivateToggle, { value: isPublic ? 'Public' : 'Private', onChange: function (newValue) {
                                onToggleVisibility(id, newValue === 'Public');
                            }, variant: 'primary', size: 'small' }) })] })] }));
};
export default DocumentFileItem;
